module.exports = __webpack_public_path__ + "static/media/lotScreen.d5c7d17e.png";